import { useEffect, useState } from 'react';
import { Participant } from 'twilio-video';

export default function useParticipantNetworkQualityLevel(participant: Participant | undefined | null) {
  const [networkQualityLevel, setNetworkQualityLevel] = useState<number | null>(
    participant?.networkQualityLevel ?? null
  );

  useEffect(() => {
    if (!participant) {
      setNetworkQualityLevel(null);
      return;
    }

    const handleNetworkQualityLevelChange = (newNetworkQualityLevel: number) => {
      console.log('🔴 Network quality level changed to:', newNetworkQualityLevel, '(1=very poor, 2=poor, 3=fair, 4=good, 5=excellent)');
      setNetworkQualityLevel(newNetworkQualityLevel);
    };

    // Set initial value
    setNetworkQualityLevel(participant.networkQualityLevel ?? null);
    
    // Subscribe to changes
    participant.on('networkQualityLevelChanged', handleNetworkQualityLevelChange);
    
    return () => {
      participant.off('networkQualityLevelChanged', handleNetworkQualityLevelChange);
    };
  }, [participant]);

  return networkQualityLevel;
}
